'use client';

import { useState } from 'react';

interface DocCodeBlockProps {
  html: string;        // pre-rendered Shiki HTML (from server)
  code: string;        // raw code for copy
  lang?: string;
  filename?: string;
}

export function DocCodeBlockClient({ html, code, lang, filename }: DocCodeBlockProps) {
  const [copied, setCopied] = useState(false);

  function copy() {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <div className="group relative my-5 overflow-hidden rounded-xl border border-[#2A2A2A] bg-[#111111]">
      {/* Header bar */}
      <div className="flex items-center justify-between border-b border-[#2A2A2A] bg-[#0D0D0D] px-4 py-2">
        <div className="flex items-center gap-3">
          {/* Traffic lights (decorative) */}
          <div className="flex gap-1.5">
            <div className="h-3 w-3 rounded-full bg-[#FF5F57]" />
            <div className="h-3 w-3 rounded-full bg-[#FEBC2E]" />
            <div className="h-3 w-3 rounded-full bg-[#28C840]" />
          </div>
          {filename && (
            <span className="font-mono text-xs text-[#6B7280]">{filename}</span>
          )}
          {!filename && lang && (
            <span className="font-mono text-xs text-[#6B7280]">{lang}</span>
          )}
        </div>
        <button
          onClick={copy}
          className="flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs text-[#6B7280] transition-all hover:bg-[#1A1A1A] hover:text-[#A1A1AA]"
        >
          {copied ? (
            <>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M2 6l3 3 5-5" stroke="#28C840" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="text-[#28C840]">Copied!</span>
            </>
          ) : (
            <>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <rect x="4" y="1" width="7" height="8" rx="1" stroke="currentColor" strokeWidth="1.2"/>
                <path d="M1 4v7h7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
              </svg>
              Copy
            </>
          )}
        </button>
      </div>

      {/* Highlighted code */}
      <div
        className="overflow-x-auto p-5 text-[0.8125rem] leading-[1.7] [&_code]:block [&_code]:whitespace-pre [&_.line]:block"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </div>
  );
}
